export default __webpack_public_path__ + "static/media/Serena Correa - Operations Associate.184f25c0.jpg";